import React from 'react';

export default function BookingActionShell({
  kicker = 'Interview scheduling',
  title,
  subtitle,
  children,
  footer,
}) {
  return (
    <div className="live-interview-page li-booking-action-page">
      <div className="live-interview-shell li-booking-action-shell">
        <header className="live-interview-header li-booking-action-header">
          <div>
            <p className="live-interview-kicker">{kicker}</p>
            <h1 className="live-interview-title">{title}</h1>
            {subtitle ? <p className="live-interview-subtitle">{subtitle}</p> : null}
          </div>
        </header>

        <div className="li-booking-action-body">{children}</div>

        {footer ? <div className="li-booking-action-footer">{footer}</div> : null}
      </div>
    </div>
  );
}
